import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["content"]

import { computed, watch, ref } from "vue";
import { getRandomId } from "@/mixins/global.mixin";

interface Props {
  color?: string;
  size?: string;
  variant?: string;
  text?: string;
  description?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VStatus',
  props: {
    color: { default: "fc-stroke" },
    size: { default: "md" },
    variant: { default: "circle" },
    text: { default: "" },
    description: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const circleClasses = computed(() => {
  const color = `circle-color-${props.color}`;
  const size = `circle-size-${props.size}`;

  return [color, size];
});

const key = ref(getRandomId());

const badgeClasses = computed(() => `badge-color-${props.color}`);

const isShownCircle = computed(() => props.variant === "circle");

const isShowBadge = computed(() => props.variant === "badge");

const tippyConfig = computed(() => {
  return { onShow: () => !!props.description };
});

watch(
  () => props.description,
  () => {
    key.value = getRandomId();
  }
);

return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    key: key.value,
    class: "status-container",
    content: _ctx.description
  }, [
    (isShownCircle.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["circle", circleClasses.value])
        }, null, 2))
      : _createCommentVNode("", true),
    (isShowBadge.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([badgeClasses.value, "badge"])
        }, _toDisplayString(_ctx.text), 3))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1)), [
    [_directive_tippy, tippyConfig.value]
  ])
}
}

})